import { useCountryStore } from '../store/country'

/**
 * Force user's to old planning page
 */
export default defineNuxtRouteMiddleware((to) => {
  const countryStore = useCountryStore()
  if (to.path === '/dashboard/planning') {
    return navigateTo(countryStore.backend + '/dashboard/planning', { external: true })
  }
})
